export default "__VITE_ASSET__y_39ucRn__"